import { createApiHandler } from './handler';

const posts = {
  apiClient: null,
  path: '/admin/posts',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async productOptions(q = '') {
    const query = q ? `?q=${encodeURIComponent(q)}` : '';
    const response = await this.apiClient.get(`${this.path}/product-options${query}`);
    return response.data;
  },

  async saveCover(postId, formData) {
    const response = await this.apiClient.post(`${this.path}/${postId}/cover`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async removeCover(postId) {
    const response = await this.apiClient.delete(`${this.path}/${postId}/cover`);
    return response.data;
  },

  async uploadInlineImage(file) {
    const formData = new FormData();
    formData.append('image', file);
    const response = await this.apiClient.post(`${this.path}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default posts;
